import React from 'react'

export const LayoutComponent = ({children}) => {
  return (
    <div>
      {children}
    </div>
  )
}
